import {
    useMemo, useCallback,
    useState,
} from 'react'
import noop from 'lodash/noop'
import {
    GridCallbackDetails,
    GridSortModel,
} from '@mui/x-data-grid-pro'

import useSkyDataGridLocalStorage from 'app/PoC/DataGridDemoPages/components/hooks/useSkyDataGridLocalStorage'

import {
    SkyDataGridLocalStorage,
} from '../SkyBaseDataGrid.types'

const sortModelInitState: SkyDataGridLocalStorage = {
    sortModel: [],
}

const usePersistedSortingModel = ({
    persistentKey,
    onChange = noop,
    enablePersistence = true,
}:{
    persistentKey: string,
    onChange?: () => void,
    enablePersistence?: boolean,
}): [GridSortModel, (model: GridSortModel, details: GridCallbackDetails) => void] => {
    const {
        dataGridState,
        setDataGridState: setLocalFilterModel,
    } = useSkyDataGridLocalStorage<SkyDataGridLocalStorage>(persistentKey, sortModelInitState)

    const [
        localSortModel,
        setLocalSortModel,
    ] = useState<GridSortModel>([])

    const onSortModelChange = useCallback((newSortModel: GridSortModel) => {
        if (enablePersistence) {
            setLocalFilterModel({
                sortModel: newSortModel,
            })
        } else {
            setLocalSortModel(newSortModel)
        }
        onChange()
    }, [
        onChange,
        setLocalFilterModel,
        enablePersistence,
    ])

    const sortModel = useMemo(() => {
        if (enablePersistence) {
            return dataGridState?.sortModel || []
        }
        return localSortModel
    }, [
        dataGridState?.sortModel,
        enablePersistence,
        localSortModel,
    ])

    return [
        sortModel,
        onSortModelChange,
    ]
}

export default usePersistedSortingModel
